import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Page } from './styled'
import actions from '../../store/actions'
import Menu from '../../components/Menu'
import { withTranslation } from 'react-i18next'
import './style.scss'
import { TopPageLink } from '../../components'
import helpVideosData from '../../components/NewHeader/SharelookHelpModal/helpVideosData'
import history from '../../history'
import { Badge, Input } from 'antd'
import { CalendarOutlined } from '@ant-design/icons'
import { withRouter } from 'react-router-dom'
import { Terms, PrivacyPolicy, ContactUs, Feedback } from './internal'
import moment from 'moment'
const { Search } = Input
class HelpCenter extends Component {
  constructor(props) {
    super(props)
    this.state = {
      searchQuery: '',
      selectedVideo: null,
      activeComponent: null,
      activeViewType: 'user' // 'user' or 'admin'
    }
  }

  componentDidMount() {
    this.checkCurrentRoute()
  }

  componentDidUpdate(prevProps) {
    // Check if the route has changed
    const prevPath = prevProps.location && prevProps.location.pathname
    const currentPath = this.props.location && this.props.location.pathname
    if (prevPath !== currentPath) {
      this.checkCurrentRoute()
    }
  }

  checkCurrentRoute = () => {
    const currentPath = history.location.pathname
    if (
      currentPath.startsWith('/help-center/') &&
      currentPath !== '/help-center' &&
      currentPath !== '/help-center/feedback' &&
      currentPath !== '/help-center/whats-new' &&
      currentPath !== '/help-center/terms-and-conditions' &&
      currentPath !== '/help-center/privacy-policy' &&
      currentPath !== '/help-center/contact-us'
    ) {
      // Extract the route from the URL
      const routeFromUrl = currentPath.replace('/help-center/', '')

      // Find the video that matches this route
      const allVideos = Object.values(helpVideosData).flat()
      const matchingVideo = allVideos.find(
        video => video.route === routeFromUrl
      )

      // Only set the video if it exists and has a valid videoUrl
      if (matchingVideo && matchingVideo.videoUrl && matchingVideo.videoUrl.trim() !== '') {
        this.setState({
          selectedVideo: matchingVideo,
          activeComponent: null,
          activeViewType: matchingVideo.viewType || 'user'
        })
      } else {
        // If no valid video found, redirect to main help center
        history.push('/help-center')
      }
    } else if (currentPath === '/help-center') {
      this.setState({
        selectedVideo: null,
        activeComponent: null,
        searchQuery: '' // Also clear search
      })
    } else if (currentPath === '/help-center/whats-new') {
      this.setState({ selectedVideo: null, activeComponent: 'whatsnew' })
    } else if (currentPath === '/help-center/feedback') {
      this.setState({ selectedVideo: null, activeComponent: 'feedback' })
    } else if (currentPath === '/help-center/terms-and-conditions') {
      this.setState({ selectedVideo: null, activeComponent: 'terms' })
    } else if (currentPath === '/help-center/privacy-policy') {
      this.setState({ selectedVideo: null, activeComponent: 'privacy' })
    } else if (currentPath === '/help-center/contact-us') {
      this.setState({ selectedVideo: null, activeComponent: 'contact' })
    }
  }

  handleSearch = e => {
    this.setState({ searchQuery: e.target.value })
  }

  clearSearch = () => {
    this.setState({ searchQuery: '' })
  }

  handleVideoSelect = video => {
    history.push(`/help-center/${video.route}`)
    this.setState({ selectedVideo: video })
  }

  handleViewTypeChange = viewType => {
    this.setState({
      activeViewType: viewType,
      selectedVideo: null,
      searchQuery: ''
    })
    if (history.location.pathname !== '/help-center') {
      history.push('/help-center')
    }
  }

  // Helper function to ensure YouTube URLs work properly with embedding
  getEmbedUrl = (url) => {
    if (!url) return ''

    // If it's already an embed URL, ensure it has proper parameters
    if (url.includes('/embed/')) {
      // Add parameters to help with embedding restrictions
      const separator = url.includes('?') ? '&' : '?'
      return `${url}${separator}rel=0&modestbranding=1&enablejsapi=1`
    }

    // If it's a watch URL, convert to embed
    if (url.includes('watch?v=')) {
      const videoId = url.split('watch?v=')[1].split('&')[0]
      return `https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1&enablejsapi=1`
    }

    // If it's a youtu.be URL, convert to embed
    if (url.includes('youtu.be/')) {
      const videoId = url.split('youtu.be/')[1].split('?')[0]
      return `https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1&enablejsapi=1`
    }

    return url
  }

  // Category display names mapping
  getCategoryDisplayName = category => {
    const { t } = this.props
    const categoryMap = {
      helpCenter: t('help_center:menu:help_center'),
      training: t('v4:training'),
      courses: t('reports:courses'),
      coursesAi: t('v3:ai_course_creation'),
      coursesBuilder: t('v5:course_builder'),
      maze: t('v2:Metamaze'),
      library: t('helplist:media_library'),
      reports: t('navigation:reports'),
      skillJourney: t('helplist:skill_journey'),
      podcast: t('general:podcast'),
      channel: t('v5:video_channel'),
      reel: t('v5:short_videos'),
      trivia: t('v4:trivia'),
      management: t('v5:user_management'),
      coaching: t('v3:coaching'),
      workshop: t('reports:WorkShop'),
      leaderboard: t('v4:leaderboard'),
      marketplace: t('v5:marketplace')
    }
    return categoryMap[category] || category
  }

  render() {
    const { t } = this.props
    const {
      searchQuery,
      selectedVideo,
      activeComponent,
      activeViewType
    } = this.state
    const currentPath = history.location.pathname

    const whatsNewVideos = [
      {
        title: '',
        description: t('helplist:whats_new_desc'),
        uploadDate: '2025-11-12', // Update this date when video is uploaded
        videoUrl:
          'https://www.youtube.com/embed/gzeajhP6CMo?si=RRB_-AVTR3QwEBSp'
      }
    ]

    // Organize videos by category and filter by viewType
    const normalizedQuery = (searchQuery || '').trim().toLowerCase()
    const videosByCategory = {}

    Object.keys(helpVideosData).forEach(category => {
      const categoryVideos = helpVideosData[category].filter(video => {
        // Filter out videos without a videoUrl
        if (!video.videoUrl || video.videoUrl.trim() === '') return false

        // Filter by viewType
        if (video.viewType !== activeViewType) return false

        // Filter by search query if present
        if (normalizedQuery) {
          const title = (t(video.title) || '').toLowerCase()
          const desc = (t(video.description) || '').toLowerCase()
          return (
            title.includes(normalizedQuery) || desc.includes(normalizedQuery)
          )
        }

        return true
      })

      if (categoryVideos.length > 0) {
        videosByCategory[category] = categoryVideos
      }
    })

    // Determine if help center menu should be active
    // Active when on main help-center page OR when on any video route
    const isHelpCenterActive =
      currentPath === '/help-center' ||
      (currentPath.startsWith('/help-center/') &&
        currentPath !== '/help-center/feedback' &&
        currentPath !== '/help-center/terms-and-conditions' &&
        currentPath !== '/help-center/privacy-policy' &&
        currentPath !== '/help-center/whats-new' &&
        currentPath !== '/help-center/contact-us')

    const menuItems = [
      {
        url: '/help-center',
        exact: true,
        heading: t('menu.help_center'),
        active: isHelpCenterActive
      },
      {
        url: '/help-center/whats-new',
        exact: true,
        heading: t('menu.whats_new'),
        active: activeComponent === 'whatsnew'
      },
      {
        url: '/help-center/feedback',
        exact: true,
        heading: t('menu.feedback'),
        active: activeComponent === 'feedback'
      },
      {
        url: '/help-center/terms-and-conditions',
        exact: true,
        heading: t('menu.terms_and_conditions'),
        active: activeComponent === 'terms'
      },
      {
        url: '/help-center/privacy-policy',
        exact: true,
        heading: t('menu.privacy_policy'),
        active: activeComponent === 'privacy'
      },
      {
        url: '/help-center/contact-us',
        exact: true,
        heading: t('menu.contact_us'),
        active: activeComponent === 'contact'
      }
    ]
    const isNewVideo = createdDate => {
      const videoDate = new Date(createdDate)
      const currentDate = new Date()
      const diffTime = Math.abs(currentDate - videoDate)
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
      return diffDays <= 7
    }

    const getMostRecentVideo = () => {
      if (!whatsNewVideos || whatsNewVideos.length === 0) return null
      const sortedVideos = [...whatsNewVideos].sort((a, b) => {
        const dateA = new Date(a.uploadDate)
        const dateB = new Date(b.uploadDate)
        return dateB - dateA // Descending order
      })
      return sortedVideos[0]
    }

    const currentWhatsNewVideo = getMostRecentVideo()

    return (
      <div className="help-center-wrap">
        <Page>
          <TopPageLink page="Dashboard" path="/" />
          <div className="help-center-layout">
            {/* Left Navigation Sidebar */}
            <div className="left-sidebar">
              {/* Video List Section */}
              <div className="video-list-section">
                {/* View Type Tabs */}
                <div className="view-type-tabs">
                  <button
                    className={`view-tab ${activeViewType === 'user' ? 'active' : ''
                      }`}
                    onClick={() => this.handleViewTypeChange('user')}
                  >
                    {t('helplist:user_view') || 'User View'}
                  </button>
                  <button
                    className={`view-tab ${activeViewType === 'admin' ? 'active' : ''
                      }`}
                    onClick={() => this.handleViewTypeChange('admin')}
                  >
                    {t('helplist:admin_view') || 'Admin View'}
                  </button>
                </div>

                <Search
                  placeholder={t('v5:search_by_title_or_description')}
                  value={searchQuery}
                  onChange={this.handleSearch}
                  allowClear
                />
                <div className="video-list">
                  {Object.keys(videosByCategory).length > 0 ? (
                    Object.keys(videosByCategory).map(category => {
                      const categoryVideos = videosByCategory[category]
                      return (
                        <div key={category} className="video-category-group">
                          <div className="category-header">
                            {this.getCategoryDisplayName(category)}
                          </div>
                          <div className="category-videos">
                            {categoryVideos.map(video => {
                              const videoKey =
                                video.route ||
                                video.videoUrl ||
                                video.id ||
                                t(video.title)
                              const isSelected =
                                selectedVideo &&
                                selectedVideo.route === video.route
                              return (
                                <div
                                  key={videoKey}
                                  onClick={() => this.handleVideoSelect(video)}
                                  className={`video-item ${isSelected ? 'selected' : ''
                                    }`}
                                  title={t(video.title)}
                                >
                                  <div className="video-title">
                                    {t(video.title)}
                                  </div>
                                  <div>
                                    {isNewVideo(video.createdDate) && (
                                      <Badge
                                        count={t('v4:new').toUpperCase()}
                                        className="new-badge"
                                      />
                                    )}
                                  </div>
                                </div>
                              )
                            })}
                          </div>
                        </div>
                      )
                    })
                  ) : (
                    <p className="no-results">
                      {normalizedQuery.length > 0
                        ? `${t('helplist:no_video_found')} "${searchQuery}"`
                        : t('helplist:no_videos_available') ||
                        'No videos available'}
                    </p>
                  )}
                </div>
              </div>
            </div>

            {/* Right Main Content Area */}
            <div className="right-content">
              {/* Menu Section */}
              <div className="menu-section">
                <Menu items={menuItems} />
              </div>
              <div className="body-section">
                {selectedVideo ? (
                  <div className="video-section">
                    <div className="video-content">
                      <h2 className="video-heading">
                        {t(selectedVideo.title)}{' '}
                        {isNewVideo(selectedVideo.createdDate) && (
                          <Badge
                            count={t('v4:new').toUpperCase()}
                            className="new-badge-large"
                          />
                        )}
                      </h2>

                      <div className="video-iframe">
                        <iframe
                          src={this.getEmbedUrl(selectedVideo.videoUrl)}
                          title={t(selectedVideo.title)}
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                        />
                      </div>
                      {selectedVideo.videoUrl && (
                        <div className="video-fallback-link" style={{ marginTop: '5px', fontSize: '12px', color: '#666', textAlign: 'right' }}>
                          {t('v5:video_not_loading') || 'Video not loading?'}{' '}
                          <a
                            href={selectedVideo.videoUrl.replace('/embed/', '/watch?v=')}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: '#1890ff' }}
                          >
                            {t('v5:watch_on_youtube') || 'Watch on YouTube'}
                          </a>
                        </div>
                      )}
                      <div className="video-description-content">
                        <p>{t(selectedVideo.description)}</p>
                      </div>
                    </div>
                  </div>
                ) : activeComponent === 'whatsnew' ? (
                  currentWhatsNewVideo ? (
                    <div className="video-section">
                      <div className="video-content">
                        <h2 className="video-heading">
                          {t('helplist:whats_new_sharelook')}{' '}
                          <Badge
                            count={t('v4:new').toUpperCase()}
                            className="new-badge-large"
                          />
                        </h2>
                        <div className="video-upload-date">
                          <CalendarOutlined className="upload-date-icon" />
                          <span className="upload-date-text">
                            {t('helplist:uploaded_on')}{' '}
                            {moment(currentWhatsNewVideo.uploadDate).format(
                              'MMM Do YYYY'
                            )}
                          </span>
                        </div>
                        <div className="video-iframe">
                          <iframe
                            src={this.getEmbedUrl(currentWhatsNewVideo.videoUrl)}
                            title={t(currentWhatsNewVideo.title)}
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                          />
                        </div>
                        <div className="video-description-content">
                          <p>{t(currentWhatsNewVideo.description)}</p>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="welcome-content">
                      <h2>{t('helplist:whats_new')}</h2>
                      <p>{t('helplist:no_video_available')}</p>
                    </div>
                  )
                ) : activeComponent === 'feedback' ? (
                  <Feedback />
                ) : activeComponent === 'terms' ? (
                  <Terms />
                ) : activeComponent === 'privacy' ? (
                  <PrivacyPolicy />
                ) : activeComponent === 'contact' ? (
                  <ContactUs />
                ) : (
                  // Show welcome content for main help-center page
                  <div className="welcome-content">
                    <h2>{t('helplist:welcome')}</h2>
                    <p>{t('helplist:video_filter')}</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Page>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  user: state.user,
  topics: state.topics
})

const mapDispatchToProps = dispatch => ({
  updateUser: (id, data, dbData) =>
    dispatch(actions.user.updateUser(id, data, dbData)),
  upload: (file, opts) => dispatch(actions.library.upload(file, opts))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withTranslation('help_center')(HelpCenter)))
